import React from 'react';
import { Flex, FormControl, FormLabel } from '@chakra-ui/react';
import TextError from '../common/TextError';
import Required from '../common/Required';

export default function CustomRadioButton(props) {
    const { formik, label, name, id, required, options=[] } = props;

    return (
        <FormControl id={id}>
            <FormLabel>
                {label}
                {required ? <Required /> : ''}
            </FormLabel>
            
            <Flex gap={5} className='custom-radio'>
                {options.map((option, key) => (
                    <div key={key}>
                        <input 
                            type='radio'
                            name={name}
                            id={`${name}-${key}`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur} 
                            value={option.key}
                            checked={formik.values[name] === option.key} 
                        />
                        <label htmlFor={`${name}-${key}`}>{option.value}</label>
                    </div>
                ))}
            </Flex>
            {formik.touched[name] && formik.errors[name] &&
                <TextError val={formik.errors[name]} />
            }
        </FormControl>
    )
}